// extracted by mini-css-extract-plugin
module.exports = {"wherebyEventLogo":"DefaultMeetingEventLogo_wherebyEventLogo__1IMGS"};